import { marketingAdministratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { communicationPageActions, communicationPageBadges } from "./communicationPageActions";
import {
  CommunicationBody,
  LazyCommunicationAudienceSummary,
  LazyCommunicationLayoutPicker,
  LazyCommunicationRunAtValidation,
  LazyCommunicationSubject,
  LazyCommunicationTestData,
} from "./communicationLazy";
import { communicationPageConfig } from "./communicationPageConfig";
import {
  adaptCommunicationRecord,
  addTemplate,
  communicationSaveConfirmation,
  communicationSaveMenu,
  newCommunicationRecord,
  toCommunicationPayload,
} from "./communicationRecord";
import {
  communicationBehaviours,
  communicationMinDates,
  communicationOptionFilters,
  communicationValidators,
  communicationVisibilityRules,
} from "./communicationRules";

export const communicationRecordDefinition: RecordDefinition = {
  path: "/email-communication",
  entityName: "g4c_communication",
  listRoute: "/email-communications",
  backTitle: "Back to email communications",
  allowedRoles: marketingAdministratorRoles,
  config: communicationPageConfig,
  // The designer fills the page, so there are no other views to design.
  authorable: false,
  body: CommunicationBody,
  saveMenu: communicationSaveMenu,
  beforeSave: addTemplate,
  fieldComponents: {
    communicationAudienceSummary: LazyCommunicationAudienceSummary,
    communicationTestData: LazyCommunicationTestData,
    communicationRunAtValidation: LazyCommunicationRunAtValidation,
    communicationLayout: LazyCommunicationLayoutPicker,
    communicationSubject: LazyCommunicationSubject,
  },
  actions: communicationPageActions,
  badges: communicationPageBadges,
  saveConfirmation: communicationSaveConfirmation,
  identity: {
    titleFields: ["g4c_name"],
    fallbackTitle: "Communication",
    newRecordTitle: "New Communication",
  },
  newRecord: newCommunicationRecord,
  toSavePayload: toCommunicationPayload,
  visibilityRules: communicationVisibilityRules,
  fieldValidators: communicationValidators,
  fieldMinDates: communicationMinDates,
  recordAdapter: adaptCommunicationRecord,
  fieldBehaviours: communicationBehaviours,
  lookupOptionFilters: communicationOptionFilters,
};
